import { ExternalComponentMissingExportError, ExternalComponentWrongExportError } from '../errors'

type ExternalDependencies = { react: any; 'react-dom': any }
type ExternalDependenciesWithAliases = { react: any; 'react-dom': any; React: any }

const fixSourceMap = (script: string, sourceUrl: string) => {
	return [script, `//# sourceURL=${sourceUrl}`].join('\n')
}
const loadUmdModule = async (
	scriptContent: string,
	modulePath: string,
	externalDependencies: ExternalDependencies,
	{ sourceUrl }: { sourceUrl: string }
) => {
	const g = typeof self !== 'undefined' ? self : globalThis

	const externalDependenciesMap: ExternalDependenciesWithAliases = {
		...externalDependencies,
		React: externalDependencies.react,
	}

	// Add AMD define function to global scope, load the script and then remove it
	return new Promise<{ [key: string]: React.ComponentType<any> }>((resolve, reject) => {
		// @ts-ignore
		g.define = Object.assign(
			(deps: Array<keyof ExternalDependenciesWithAliases>, callback: (...args: Array<any>) => any) => {
				const resolvedDeps = deps.map((dep) => externalDependenciesMap[dep])
				const module = callback(...resolvedDeps)

				const invalidImportKey = Object.keys(module).find((key) => !module[key])
				if (invalidImportKey) {
					reject(new ExternalComponentWrongExportError(invalidImportKey, modulePath))
				} else if (Object.keys(module).length === 0) {
					reject(new ExternalComponentMissingExportError(modulePath))
				} else {
					resolve(module)
				}
			},
			{ amd: true }
		)

		const scriptContentWithSourceMap = fixSourceMap(scriptContent, sourceUrl)

		// eslint-disable-next-line no-eval
		eval.call(null, scriptContentWithSourceMap)()

		// @ts-ignore
		delete g.define
	})
}

export default loadUmdModule
